import IndexModel from "@/service/v10/sigap/IndexModel";
 
class AlocacaoService extends IndexModel { 
       
    constructor() {
        super();
        this.url =  this.url + '/Alocacao' ;  
    }
 
    public getApiUrl(  ) { 
        return this.getAxios().defaults.baseURL + this.url; 
    }

 
    public getModel( id  ) : Promise<any> { 
        return  new Promise((resolve, reject) => {
            this.getAxios().get( this.url + '/' + id    )
            .then(response => {    
                resolve( response.data);  
            })
            .catch(error => {  
                reject(error.response);
            }) 
        }); 
    }
 

    public getTodos(search) : Promise<any> {  
        if(search){
            return  new Promise((resolve, reject) => {
                this.getAxios().get( this.url + '?search=' + search    )
                .then(response => {    
                    resolve( response.data);  
                })
                .catch(error => {  
                    reject(error.response);
                }) 
            }); 
        } 
        return  new Promise((resolve, reject) => {
            this.getAxios().get( this.url )
            .then(response => {    
                resolve( response.data);  
            })
            .catch(error => {  
                reject(error.response);
            }) 
        }); 
    }
 
    
    public getOpcao( ) : Promise<any> { 
        return  new Promise((resolve, reject) => {
            this.getAxios().get( this.url  + '/GetOpcao'   , {}  )
            .then(response => {    
                resolve( response.data);  
            })
            .catch(error => {  
                reject(error.response);
            }) 
        }); 
    }

}
  
export default AlocacaoService; 